import { createSlice } from '@reduxjs/toolkit'
import {
  addToCartAPI,
  deleteItemInCartAPI,
  getCartAPI,
  modifyItemInCartAPI
} from '../actions/cart-actions'
import { Product } from './productReducers'

export type CartItem = {
  _id: string
  user_id: string
  quantity: number
  __v: number
  product: Product
}

export interface Payload {
  success: boolean
  carts?: CartItem[]
  message?: string | null
}
export type Cart = {
  success: boolean
  loading: boolean
  cart: CartItem[]
  message?: string
}

const initialState: Cart = {
  success: false,
  cart: [],
  loading: false,
  message: undefined
}

export const authSlices = createSlice({
  name: 'cart',
  initialState,
  reducers: {},
  extraReducers: builders => {
    builders
      .addCase(addToCartAPI.fulfilled, (state, action) => {
        state.success = action.payload.success
        state.message = action.payload.message
        state.loading = false
      })
      .addCase(addToCartAPI.pending, state => {
        state.loading = true
        state.message = undefined
      })
      .addCase(addToCartAPI.rejected, (state, action) => {
        state.success = action.payload?.success || false
        state.message = action.payload?.message
        state.loading = false
      })
      .addCase(getCartAPI.fulfilled, (state, action) => {
        state.success = action.payload.success
        state.loading = false
        state.cart = action.payload.carts || []
        state.message = action.payload?.message || ''
      })
      .addCase(getCartAPI.pending, state => {
        state.loading = true
        state.message = undefined
      })
      .addCase(getCartAPI.rejected, (state, action) => {
        state.success = action.payload?.success || false
        state.message = action.payload?.message || ''
        state.loading = false
        state.cart = []
      })
      // DELETE ITEM IN CART API
      .addCase(deleteItemInCartAPI.fulfilled, (state, action) => {
        state.success = action.payload.success
        state.message = action.payload.message
        state.loading = false
      })
      .addCase(deleteItemInCartAPI.pending, state => {
        state.loading = true
        state.message = undefined
      })
      .addCase(deleteItemInCartAPI.rejected, (state, action) => {
        state.success = action.payload?.success || false
        state.message = action.payload?.message
        state.loading = false
      })
      // MODIFY ITEM IN CART API
      .addCase(modifyItemInCartAPI.fulfilled, (state, action) => {
        state.success = action.payload.success
        state.message = action.payload.message
        state.loading = false
      })
      .addCase(modifyItemInCartAPI.pending, state => {
        state.loading = true
        state.message = undefined
      })
      .addCase(modifyItemInCartAPI.rejected, (state, action) => {
        state.success = action.payload?.success || false
        state.message = action.payload?.message
        state.loading = false
      })
    // .addCase(removeFromCartAPI.rejected, (state, action) => {
    //   state.err = action.payload??.message as string
    // })
  }
})

export default authSlices.reducer
